<script>
  // @ts-check
  import { fly } from "svelte/transition";
  import { cubicInOut } from "svelte/easing";

  // eslint-disable-next-line
  import * as Types from "./globalNavigationTypes";
  import Constants from "./globalNavigationConstants";
  import Rule from "../../atoms/Rule.svelte";
  import GridContainer from "../../atoms/GridContainer.svelte";
  import { getTheme } from "../../utilities/themes";

  import GlobalNavigationMobileLinkLabel from "./GlobalNavigationMobileLinkLabel.svelte";
  import GlobalNavigationSecondaryMenu from "./GlobalNavigationSecondaryMenu.svelte";

  /** @type {boolean}  */
  export let isExpanded = true;

  /** @type {Types.MainNavigation} */
  export let mainNavigation;

  /** @type {import('../../utilities/themes').ThemeName}*/
  export let theme;

  /** @type {string} label of active section */
  export let displayedMobileSection = undefined;

  /** @type {HTMLElement | undefined} */
  export let scrollableContainer = undefined;

  /** @type {HTMLElement | undefined} */
  export let scrollableContent = undefined;

  let innerHeight;
  $: colorTheme = getTheme(theme);

  let containerClass = "absolute bottom-0 w-[calc(100%-3.75rem)] lg:w-[calc(100vw-7.5rem)] pb-10";
</script>

<svelte:window bind:innerHeight />

{#if mainNavigation?.length > 0 && isExpanded}
  <div class="h-full min-h-dvh w-full {colorTheme.backgroundColor}">
    <GridContainer containerClass="flex h-full overflow-hidden">
      <ul
        bind:this={scrollableContainer}
        class="{containerClass} max-h-[calc(100dvh-var(--nav-height)-40px)] overflow-y-auto"
        in:fly={{ y: -30, duration: 300, delay: 450, easing: cubicInOut }}
        out:fly={{ y: -30, duration: 150, easing: cubicInOut }}
      >
        {#each mainNavigation as primarySection (primarySection.link.label)}
          {#if displayedMobileSection === undefined}
            <li
              class="flex flex-col justify-between [&:not(:first-of-type)]:mt-4"
              in:fly={{ x: -30, duration: 300, delay: 300, easing: cubicInOut }}
              out:fly={{ x: -30, duration: 300, easing: cubicInOut }}
            >
              <Rule type="thin" {theme} />
              <GlobalNavigationMobileLinkLabel
                on:mobileLabelClicked
                {theme}
                link={primarySection?.link}
                {displayedMobileSection}
              />
            </li>
          {/if}
        {/each}
      </ul>
      {#each mainNavigation as primarySection (primarySection.link.label)}
        {@const isThisSectionBeingDisplayed =
          primarySection?.link?.label === displayedMobileSection}
        {@const primaryLinkLabel = primarySection?.link?.label.replace(/\s/g, "")}

        {#if isThisSectionBeingDisplayed}
          <div
            class={containerClass}
            id={Constants.secondarySectionPrefixMobile + primarySection?.link?.label}
            aria-labelledby={Constants.primaryLinkPrefixMobile + primarySection?.link?.label}
            in:fly={{ x: 30, duration: 300, delay: 300, easing: cubicInOut }}
            out:fly={{ x: 30, duration: 300, easing: cubicInOut }}
          >
            {#if primarySection.secondarySections?.length}
              {@const primarySectionLinks = primarySection.link ? [primarySection.link] : []}
              {@const secondarySectionLinks = primarySection.secondarySections?.flatMap(
                (section) => {
                  if (section.type === "section") {
                    return section.links;
                  }
                  return [];
                }
              )}
              {@const links = primarySectionLinks.concat(secondarySectionLinks).map((link) => {
                link.id = `${Constants.secondarySectionLinkPrefixMobile}${link?.label.replace(/\W/g, "")}-${primaryLinkLabel}`;
                return link;
              })}
              <GlobalNavigationSecondaryMenu
                {links}
                {theme}
                menuListClass="overflow-y-auto h-auto max-h-[calc(100dvh-var(--nav-height)-40px)]"
                bind:ref={scrollableContent}
              />
            {/if}
          </div>
        {/if}
      {/each}
    </GridContainer>
  </div>
{/if}
